'use strict';

var clone = require('./utils/clone');
var createIntrospectableChecker = require('./utils/createIntrospectableChecker');
var React = require('react');
var PropTypes = clone(React.PropTypes);

/**
 * Common combinations of types.
 */
PropTypes.numberOrString = PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]);

PropTypes.boolOrString = PropTypes.oneOfType([React.PropTypes.bool, React.PropTypes.string]);

['shape', 'arrayOf', 'oneOf', 'oneOfType'].forEach(function (type) {
  PropTypes[type] = createIntrospectableChecker(type, React.PropTypes[type]);
});

// ----------------------------------------------------------------------------
module.exports = PropTypes;
//# sourceMappingURL=PropTypes.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-schema/lib/PropTypes.js
 ** module id = 963
 ** module chunks = 0
 **/